import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { inputCls, Btn } from "@/admin/ui";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/api/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(apiError(err)); }
  };
  return (
    <Shell testid="admin-forgot">
      {sent ? (
        <div className="text-center">
          <p className="text-ink-body">If an account exists for <b>{email}</b>, a reset link has been generated. Check the server logs for the link (email delivery is configured for go-live).</p>
          <Link to="/admin/login" className="mt-4 inline-block text-azeka-teal font-medium">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <h1 className="text-center text-xl font-semibold text-ink-heading">Reset your password</h1>
          <input type="email" placeholder="Email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          <Btn type="submit" className="w-full" data-testid="forgot-submit">Send reset link</Btn>
          <Link to="/admin/login" className="block text-center text-xs text-ink-muted hover:text-azeka-teal">Back to sign in</Link>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/api/auth/reset-password", { token, password }); toast.success("Password updated — please sign in"); nav("/admin/login"); }
    catch (err) { toast.error(apiError(err)); }
  };
  return (
    <Shell testid="admin-reset">
      <form onSubmit={submit} className="space-y-4">
        <h1 className="text-center text-xl font-semibold text-ink-heading">Choose a new password</h1>
        <input type="password" placeholder="New password (min 8 chars)" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password" />
        <Btn type="submit" className="w-full" data-testid="reset-submit">Update password</Btn>
      </form>
    </Shell>
  );
}

const Shell = ({ children, testid }) => (
  <div className="flex min-h-screen items-center justify-center bg-azeka-navy px-5 py-12">
    <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl" data-testid={testid}>
      <div className="mb-8 flex justify-center"><Logo className="h-11 w-auto" /></div>
      {children}
    </div>
  </div>
);
